import { Button } from "@/components/ui/button";
import { ArrowRightIcon, ShieldCheckIcon, SparkleIcon } from "@phosphor-icons/react";

export default function Hero() {
  const scrollToForm = () => {
    const el = document.getElementById("early-access");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative overflow-hidden ranq-grain"
    >
      <div className="absolute inset-0 ranq-gradient-hero" aria-hidden="true" />
      <div
        aria-hidden="true"
        className="absolute -top-32 -left-20 h-[420px] w-[420px] rounded-full bg-[#ff5e3a]/25 blur-[110px]"
      />
      <div
        aria-hidden="true"
        className="absolute -bottom-32 right-10 h-[360px] w-[360px] rounded-full bg-[#ffb59a]/30 blur-[120px]"
      />

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 pt-24 md:pt-32 pb-20 md:pb-28">
        <div className="max-w-4xl">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-stone-300/70 bg-[#f7f4ec]/70 backdrop-blur text-[12px] uppercase tracking-[0.18em] font-semibold text-stone-800 mb-8">
            <SparkleIcon size={14} weight="fill" className="text-[#ff5e3a]" />
            AI-powered submission builder
          </div>

          <h1
            data-testid="hero-headline"
            className="font-heading text-[40px] leading-[1.05] sm:text-5xl md:text-6xl lg:text-[68px] font-medium tracking-tight text-stone-900"
          >
            Your firm didn’t build its reputation
            <span className="block text-stone-500">
              for it to get lost in a submission.
            </span>
          </h1>

          <p
            data-testid="hero-subheadline"
            className="mt-8 max-w-2xl text-lg md:text-xl leading-relaxed text-stone-700"
          >
            Ranq is an AI-powered submission builder that helps law firms turn
            matters, experience and lawyer credentials into clearer, stronger
            and strategically structured submissions for{" "}
            <span className="text-stone-900 font-medium">Chambers &amp; Partners</span>{" "}
            and <span className="text-stone-900 font-medium">The Legal 500</span>.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <Button
              data-testid="hero-cta-request-access"
              onClick={scrollToForm}
              className="group h-12 px-7 rounded-full bg-stone-900 hover:bg-stone-800 text-[#f7f4ec] font-medium text-base shadow-sm"
            >
              Request early access
              <ArrowRightIcon
                size={18}
                weight="bold"
                className="ml-2 transition-transform group-hover:translate-x-0.5"
              />
            </Button>
            <div className="flex items-center gap-2 text-sm text-stone-600">
              <ShieldCheckIcon size={18} weight="duotone" className="text-stone-700" />
              No confidential information required to register.
            </div>
          </div>

          <div className="mt-14 flex flex-wrap items-center gap-x-8 gap-y-3 text-sm">
            <span className="uppercase tracking-[0.18em] text-xs font-semibold text-stone-500">
              Built for
            </span>
            <span className="font-heading text-stone-900 text-lg">Chambers &amp; Partners</span>
            <span className="h-1 w-1 rounded-full bg-stone-400" />
            <span className="font-heading text-stone-900 text-lg">The Legal 500</span>
          </div>

          <p
            data-testid="hero-region"
            className="mt-4 text-sm text-stone-600"
          >
            Early access for law firms in Mexico and Latin America.
          </p>
        </div>
      </div>
    </section>
  );
}
